import React from "react";
import "./About.css";

export default function About() {
  return (
    <section className="about-page">
      <div className="about-hero">
        <h1>About Moshiqe</h1>
        <p>
          A sacred place fostering worship, education, and community engagement.
        </p>
      </div>

      <div className="about-section">
        <h2>Our History</h2>
        <p>
          Moshiqe was established in 1985 to serve the local community and provide a peaceful place for prayer, learning, and spiritual growth. Over the years, it has become a center for Islamic education and community service.
        </p>
      </div>

      <div className="about-section">
        <h2>Our Mission</h2>
        <p>
          To nurture spiritual growth, promote community welfare, and offer a platform for learning and cultural exchange.
        </p>
      </div>

      <div className="about-section programs">
        <h2>Community Programs</h2>
        <div className="program-cards">
          <div className="program-card">
            <h3>Quran Classes</h3>
            <p>Regular classes for children and adults to learn Quran and Islamic studies.</p>
          </div>
          <div className="program-card">
            <h3>Charity & Donations</h3>
            <p>Supporting local families and global initiatives through regular charity drives.</p>
          </div>
          <div className="program-card">
            <h3>Community Iftar</h3>
            <p>Bringing together the community during Ramadan for shared meals and bonding.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
